import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Title case a single name: "sanyami" → "Sanyami", "JaiN" → "Jain" */
export function titleCase(s?: string): string {
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

/** Format full name in Title Case from firstName + lastName */
export function formatName(firstName?: string, lastName?: string): string {
  return `${titleCase(firstName)} ${titleCase(lastName)}`.trim();
}

/** Get uppercase initials from firstName + lastName */
export function getInitials(firstName?: string, lastName?: string): string {
  return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || 'U';
}
